import React from 'react';
import { Menu } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import { string, bool, shape, arrayOf, func } from 'prop-types';

import SearchField from './SearchField';

const Navigation = ({
  match,
  terms,
  loadingGenres,
  loadingStations,
  genres,
  stations,
  genre,
  showModal
}) => (
  <Menu pointing secondary style={{ backgroundColor: '#fff' }}>
    <Menu.Item>
      <SearchField
        match={match}
        terms={terms}
        loadingGenres={loadingGenres}
        loadingStations={loadingStations}
        genres={genres}
        stations={stations}
        showModal={showModal}
      />
    </Menu.Item>
    <Menu.Item as={NavLink} to="/genres/all" content={terms[0]} />
    <Menu.Item as={NavLink} to="/stations/all" content={terms[2]} />
    {genre.name && <Menu.Item name={genre.name} active />}
  </Menu>
);

Navigation.propTypes = {
  match: shape().isRequired,
  terms: arrayOf(string).isRequired,
  loadingGenres: bool.isRequired,
  loadingStations: bool.isRequired,
  genres: arrayOf(shape).isRequired,
  stations: arrayOf(shape).isRequired,
  genre: shape().isRequired,
  showModal: func.isRequired
};

export default Navigation;
